var _rect, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInviteTo88Page(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 136,
    viewBox: "0 0 194 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 82,
    width: 51,
    height: 51,
    rx: 25.5,
    transform: "rotate(90 87 82)",
    fill: "#F1EDF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.601 22.509C161.051 22.6737 161.05 23.326 160.601 23.4905C154.726 25.6413 152.641 27.7253 150.49 33.6008C150.326 34.0502 149.674 34.0504 149.509 33.601C147.357 27.7277 145.274 25.6438 139.399 23.491C138.949 23.3263 138.95 22.674 139.399 22.5095C145.274 20.3587 147.359 18.2747 149.51 12.3992C149.674 11.9498 150.326 11.9496 150.491 12.399C152.643 18.2723 154.726 20.3562 160.601 22.509Z",
    fill: "url(#paint0_linear_5355_195774)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.189 105.145V67.2031H57.8066V105.145C57.8066 109.248 61.1326 112.573 65.2352 112.573H128.76C132.863 112.573 136.189 109.248 136.189 105.145Z",
    stroke: "url(#paint1_linear_5355_195774)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97 112.571V68",
    stroke: "url(#paint2_linear_5355_195774)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.571 51.5965V59.7739C141.571 63.8766 138.245 67.2025 134.142 67.2025H59.8563C55.7537 67.2025 52.4277 63.8766 52.4277 59.7739V51.5965C52.4277 47.4938 55.7537 44.168 59.8563 44.168H134.142C138.245 44.168 141.571 47.4938 141.571 51.5965Z",
    stroke: "url(#paint3_linear_5355_195774)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9994 44.1678C96.9994 37.9464 89.7411 23.4297 78.8535 23.4297C61.1412 23.4297 67.5934 44.1678 76.071 44.1678",
    stroke: "url(#paint4_linear_5355_195774)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97 44.1678C97 37.9464 104.258 23.4297 115.146 23.4297C132.858 23.4297 126.406 44.1678 117.928 44.1678",
    stroke: "url(#paint5_linear_5355_195774)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5,
    cy: 20.5,
    rx: 4.5,
    ry: 4.5,
    transform: "rotate(90 31.5 20.5)",
    fill: "#00FFFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5355_195774",
    x1: 161.727,
    y1: 22.8033,
    x2: 122.531,
    y2: 35.9961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5355_195774",
    x1: 135.298,
    y1: 89.5164,
    x2: 28.7968,
    y2: 151.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5355_195774",
    x1: 97.9886,
    y1: 89.9204,
    x2: 96.1706,
    y2: 89.9341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5355_195774",
    x1: 140.558,
    y1: 55.4964,
    x2: 80.4559,
    y2: 133.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5355_195774",
    x1: 96.6652,
    y1: 33.6288,
    x2: 53.1194,
    y2: 54.4117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5355_195774",
    x1: 126.072,
    y1: 33.6288,
    x2: 82.5257,
    y2: 54.4118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteTo88Page);
export default __webpack_public_path__ + "static/media/invite_to_88_page.39ff2af11b02e7d8001b63e39abad4dc.svg";
export { ForwardRef as ReactComponent };